import React from 'react';
import clsx from 'clsx';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

import scss from './BootScreen.module.scss';

function BootScreen({ embedded = false }) {
  return (
    <div className={clsx(scss.root, embedded && scss.rootEmbedded)} role='status' aria-busy='true'>
      <div className={scss.brand}>
        <div className={scss.mark}>
          <span className={scss.halo} aria-hidden />
          <HexRing className={scss.ring} />
          <Icon icon={ICONS.Logo} className={scss.logo} disableCommonStyles disableCommonColors />
        </div>
        <Icon icon={ICONS.Factive} className={scss.wordmark} disableCommonStyles disableCommonColors />
      </div>
    </div>
  );
}

export default BootScreen;

function HexRing({ className }) {
  return (
    <svg className={className} viewBox='0 0 100 100' aria-hidden>
      <polygon points='50,4 93,27 93,73 50,96 7,73 7,27' fill='none' stroke='currentColor' strokeWidth='1.25' />
    </svg>
  );
}
